import React from 'react';

type Props = {
  text: string;
};

const MessageText = ({ text }: Props) => {
  return (
    <div data-testid="chat-message-text" className="max-w-[500px]">
      <p
        className="text-sm text-light-text-primary dark:text-dark-text-primary leading-relaxed break-words text-start"
        dir="auto"
        data-testid="chat-message-text-content"
      >
        {text}
      </p>
    </div>
  );
};

export default MessageText;
